import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private apiMinuteUrl = 'https://analyticsdata.googleapis.com/v1beta/properties/402935942:runRealtimeReport';

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
  ) {}

  async fetchLineChartEventsAsPerDates(start: Date, end: Date): Promise<Object> {
    const dateRanges = [
      {
        startDate: this.formatDate(start),
        endDate: this.formatDate(end),
      },
    ];

    return firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_run_report}`, {
        dimensions: [
          { name: 'date' },
          { name: 'eventName' },
          {
            name: 'customUser:user',
          },
        ],
        metrics: [],
        dateRanges: dateRanges,
      }),
    );
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  async getAnalyticsRunTimeReport(start_date, end_date, metrics, dimensions) {
    const body = {
      dateRanges: [
        {
          startDate: start_date,
          endDate: end_date,
        },
      ],
      metrics,
      dimensions,
    };
    return firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_run_report}`, body),
    );
  }

  async getAnalyticsRunTimeMinuteRangesReport(minuteRanges, metrics) {
    const body = {
      minuteRanges,
      metrics,
    };
    return firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_realtime}`, body),
    );
  }

  async getcategeoryData() {
    const currentDate = new Date();
    const endDate = formatDate(currentDate, 'yyyy-MM-dd', 'en-US');

    const body = {
      dateRanges: [
        {
          startDate: '2022-01-01',
          endDate: endDate,
        },
      ],
      dimensions: [{ name: 'deviceCategory' }],
      metrics: [{ name: 'activeUsers' }],
    };
    return firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_run_report}`, body),
    );
  }

  async getAnalyticsData(startDate: string, endDate: string) {
    const requestBody = {
      dateRanges: [
        {
          startDate: startDate,
          endDate: endDate,
        },
      ],
      metrics: [
        { name: 'activeUsers' },
        {
          name: 'newUsers',
        },
      ],
    };
    return firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_run_report}`, requestBody),
    );
  }

  async getToken() {
    const response = await firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_token}`),
    );
    return response;
  }

  getCohortData(dimensions, metrics) {
    try {
      const body = {
        dimensions,
        metrics,
        cohortSpec: {
          cohorts: [
            {
              dimension: 'firstSessionDate',
              dateRange: {
                startDate: '2023-11-01',
                endDate: '2023-11-02',
              },
            },
            {
              dimension: 'firstSessionDate',
              dateRange: {
                startDate: '2023-11-09',
                endDate: '2023-11-09',
              },
            },
            {
              dimension: 'firstSessionDate',
              dateRange: {
                startDate: '2023-11-16',
                endDate: '2023-11-16',
              },
            },
            {
              dimension: 'firstSessionDate',
              dateRange: {
                startDate: '2023-11-01',
                endDate: '2023-11-02',
              },
            },
            {
              dimension: 'firstSessionDate',
              dateRange: {
                startDate: '2023-11-09',
                endDate: '2023-11-09',
              },
            },
          ],
          cohortsRange: {
            endOffset: 5,
            granularity: 'WEEKLY',
          },
        },
      };
      return firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.google_analytics_run_report}`, body),
      );
    } catch (error) {
      throw error;
    }
  }
}
